<template>
  <div class="bg-surface-container-low h-6 w-44 shrink-0 grow-0 rounded-full">
    <div
      v-if="value != null"
      class="bg-primary-container ease-fast-spatial relative h-6 min-w-6 rounded-full transition-all duration-300"
      :style="{
        width: barWidth,
        transitionDelay,
      }"
    >
      <div
        v-if="value < 0.8"
        class="bg-primary absolute top-1/2 right-1.5 h-1 w-1 -translate-y-1/2 rounded-full"
      ></div>
      <Transition
        v-else
        appear
        appear-active-class="transition-transform duration-400 delay-100 ease-fast-spatial"
        appear-from-class="-rotate-360 scale-20"
        appear-to-class="rotate-0 scale-100"
      >
        <BaseShape
          shape="burst"
          class="text-on-primary-container absolute top-1/2 right-1 h-4.5 w-4.5 -translate-y-1/2"
        />
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue'
  import BaseShape from '../base/shapes/BaseShape.vue'

  interface Props {
    value: number | null
    transitionDelay?: string
  }

  const props = defineProps<Props>()

  const hasMounted = ref(false)

  const barWidth = computed(() => {
    if (props.value == null || !hasMounted.value) {
      return '0%'
    }
    return `${props.value * 100}%`
  })

  onMounted(() => {
    requestAnimationFrame(() => {
      hasMounted.value = true
    })
  })
</script>
